// TODO: change to agent/other ?
export enum Speaker {
  All = -1,
  Customer = 0,
  Employee = 1,
}
